import { useEffect } from 'react';

function Effect({ children: fn, dependencies }) {
  useEffect(() => fn(), dependencies || []);

  return null;
}

export default Effect;
